import { useEffect, useState } from 'react';

/**
 * Retourne `true` si l'utilisateur a activé `prefers-reduced-motion` au niveau système.
 * Utilisé pour désactiver le tilt 3D et le parallax curseur côté JS
 * (les animations CSS sont déjà neutralisées via @media dans motion.css).
 */
export function useReducedMotion() {
  const [reduced, setReduced] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    const on = (e) => setReduced(e.matches);
    mq.addEventListener?.('change', on);
    return () => mq.removeEventListener?.('change', on);
  }, []);

  return reduced;
}
